import moment from "moment";
import modelBaseV2 from '../../../models/model-base-v2.model';

/**
 * Validation fail over 10% Model
 * 
 * Contains all the requests used by Validation fail over 10% 
 * 
 * @author cmc.pbhieu
 */

const SPECIFIC_FILE_NAME = {
  TOTAL: 'FailTotal',
  FAIL: 'FailDetail',
  SUCCESS: 'Success'
}

const ValidationFailOver10PercentModel = {
  search: (params) => {
    return modelBaseV2.get('/api/datainput/imeiValidationFailOver10Percent/overall', { params });
  },

  downloadExcel: (filters) => {
    const paramsMapping = {
      logWeek: "122",
      pageSize: "4",
      type: "38"
    };

    const downloadExcelFilters = { ...filters, pageSize: '999999999' };
    const fileName = `LogFailReport_${moment().format('YYYYMMDDHHmmss')}`;

    const params = Object.entries(paramsMapping).map(([key, value]) => {
      const attr = downloadExcelFilters[key];

      return {
        code: value,
        value: attr
          ? Array.isArray(attr)
            ? attr.join('^')
            : attr.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        `LogFailReport_${moment().format('YYYYMMDDHHmmss')}`
      ],
      storedProcedureCode: "59",
      params
    }

    return modelBaseV2.postDownload(
      '/api/executesp/export/commonexcel',
      { body: exportConfig },
      fileName);
  },

  downloadSpecificExcel: (params) => {
    const fileName = `Log${SPECIFIC_FILE_NAME[params.excelType]}Report_${moment().format('YYYYMMDDHHmmss')}`;
    return modelBaseV2.getDownload(
      '/api/datainput/imeiValidationFailOver10Percent/specific',
      { params },
      fileName);
  }
};

export default ValidationFailOver10PercentModel;
